export const URLS = {
  MAIN: {
    site: 'https://designbynidhi.com/',
    og: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1749915542/design-by-nidhi/home/open-graph_j9euel.png',
  },
  HOME: {
    FAVICON: {
      light: 'https://ik.imagekit.io/arsroy5yrc/design-by-nidhi/icons/favicon/chefbook-favicon-light.svg',
      dark: 'https://ik.imagekit.io/arsroy5yrc/design-by-nidhi/icons/favicon/chefbook-favicon-dark.svg',
    },
    PROFILE: {
      src: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1749886827/design-by-nidhi/home/hero-profile-image_fhuegn.png',
      alt: 'Design by Nidhi - UX/UI Designer Cover Profile Picture',
    },
    RESUME: {
      URL: 'https://dub.sh/Kvs5JNO',
    },
    HERO_CARDS: {
      MEDIUM_ARTICLE: {
        href: 'https://dub.sh/z88kyJG',
        src: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1749886827/design-by-nidhi/home/hero-medium-article_imwdq8.png',
        alt: 'Hero Medium article',
      },
      QUOTE: {
        href: '/',
        src: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1749886827/design-by-nidhi/home/hero-quote_kdd6ad.png',
        alt: 'Hero Quote',
      },
      TOP_50_WOMEN_IN_DESIGN: {
        href: 'https://dub.sh/OdahhQm',
        src: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1749886827/design-by-nidhi/home/hero-top_50_nlecqw.png',
        alt: 'Top 50 women in design',
      },
      APPLE_DESIGN_AWARD: {
        href: 'https://dub.sh/vlzHtqs',
        src: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1749912219/design-by-nidhi/home/apple_design_award-evolve-hero_2_uiqxfk.png',
        alt: 'Apple Design Award Finalist',
      },
    },
  },
  SOCIAL_LINKS: {
    Dribbble: 'https://dribbble.com/designbynidhi',
    Medium: 'https://medium.com/@designbynidhi',
    Behance: 'https://www.behance.net/design-by-nidhi',
    Youtube: 'https://www.youtube.com/@designbynidhi',
    LinkedIn: 'https://www.linkedin.com/in/design-by-nidhi/',
    Instagram: 'https://www.instagram.com/designbynidhi/',
    Mail: 'mailto:mailto:designbynidhi@gmail.com',
  },
};
